import { render, staticRenderFns } from "./PostcardAnswers.vue?vue&type=template&id=627a4356&scoped=true&"
import script from "./PostcardAnswers.vue?vue&type=script&lang=js&"
export * from "./PostcardAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a4356",
  null
  
)

export default component.exports